import { useState, useRef } from 'react';
import { createWorker } from 'tesseract.js';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js`;

export function useTesseract(lang = 'fr', setInvoiceExtractingText: Function) {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [text, setText] = useState('');
  const [invoiceInfo, setInvoiceInfo] = useState({});

  const recognize = async (file: File) => {
    setLoading(true);
    const typedArray = new Uint8Array(await file.arrayBuffer());
    const pdf = await pdfjsLib.getDocument(typedArray).promise;

    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 2 });

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    await page.render({ canvasContext: ctx, viewport }).promise;

    const imageDataUrl = canvas.toDataURL('image/png');

    const worker = await createWorker(); // ✅ just createWorker()

    await worker.load();

    const { data } = await worker.recognize(imageDataUrl);
    await worker.terminate();

    setText(data.text);
    setInvoiceExtractingText(parseInvoiceFields(data.text));
    setLoading(false);

    return {
      fullText: data.text,
      // Example: you can extract invoice fields here if needed
      invoiceFields: parseInvoiceFields(data.text),
    };
  };
  const recognizeFromUrl = async (url: string) => {
    setLoading(true);

    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer();

    const pdf = await pdfjsLib.getDocument(new Uint8Array(arrayBuffer)).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 2 });

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    await page.render({ canvasContext: ctx, viewport }).promise;

    const imageDataUrl = canvas.toDataURL('image/png');

    const worker = await createWorker(); // ✅ just createWorker()

    await worker.load();

    const { data } = await worker.recognize(imageDataUrl);

    await worker.terminate();

    setText(data.text);

    setLoading(false);
    setInvoiceInfo(parseInvoiceFields(data.text));
    return {
      fullText: data.text,
      // Example: you can extract invoice fields here if needed
      invoiceFields: parseInvoiceFields(data.text),
    };
  };

  return {
    loading,
    progress,
    text,
    recognize,
    recognizeFromUrl,
    invoiceInfo,
    setInvoiceInfo,
  };
}

const parseInvoiceFields = (text: any) => {
  const clean = text?.replace(/\s+/g, ' ');
  const dateMatches = clean.match(
    /\b(\d{4}[\/-]\d{1,2}[\/-]\d{1,2}|\d{1,2}[\/-]\d{1,2}[\/-]\d{2,4})\b/g,
  );
  let maxDate;
  //    /(?:le\s*:?\s*)?(\d{1,4}[\/-]\d{1,2}[\/-]\d{1,4})/i,
  if (dateMatches) {
    // 2. Convertir les dates en objets Date
    const dates = dateMatches.map((d: any) => {
      const [day, month, year] = d.split(/[\/-]/).map(Number);
      return new Date(year, month - 1, day); // JS Date (mois 0-indexé)
    });

    // 3. Trouver la date la plus récente
    maxDate = new Date(Math.max(...dates.map((d: any) => d.getTime())));
  }
  ///(?:Facture(?:\s+D'HONORAIRES)?|Note\s+Honoraire)\s*(?:N[°o©]|:)?\s*#?\s*([\d]+\/[\d]+)/i,
  ///(?:Facture(?:\s+D'HONORAIRES)?|Note\s+d[’']honoraires|Note\s+Honoraire)\s*(?:N[°o©]\s*:?\s*)?#?\s*(\d{1,4}\/\d{1,4})/i

  const regex = /(?:Facture|Note\s*d['’]?\s*honoraires?|Note\s*honoraire)[\s\S]{0,50}?N[\s\u00A0]*[°ºo©]?\s*:?\s*(\d{1,6}(?:\s*\/\s*\d{1,6})?)/i;
  return {
    invoiceNumber: match(clean, regex),
    invoiceDate: maxDate?.toLocaleDateString() ?? null,
  };
};
const match = (text: string, regex: RegExp) => {
  return text.match(regex)?.[1]?.trim() ?? null;
};
